import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import TableHead from './TableHead';

class TableHeads extends PureComponent {
  render() {
    const { tableHeads } = this.props;
    const tableHeadList = tableHeads.map(
      tableHead => <TableHead key={tableHead.id} tableHead={tableHead} />,
    );
    return (
      <thead>
        <tr>
          { tableHeadList }          
        </tr>
      </thead>
    );
  }
}

// props validation
TableHeads.propTypes = {
  tableHeads: PropTypes.arrayOf(PropTypes.object),
};

TableHeads.defaultProps = {
  tableHeads: [{
    id: '1',
    name: 'N°',
    class: 'w-5',
    prop: 'id'
  }, {
    id: '2',
    name: 'Código',
    class: 'w-10',
    prop: 'code'
  }, {
    id: '3',
    name: 'Clase',
    class: 'w-11',
    prop: 'class'
  }, {
    id: '4',
    name: 'Tipo',
    class: 'w-9',
    prop: 'type'
  }, {
    id: '5',
    name: 'Nombre',
    class: 'w-5',
    prop: 'name'
  }, {
    id: '6',
    name: 'Modificación contractual',
    class: 'w-9',
    prop: 'contractMondification'
  }, {
    id: '7',
    name: 'Mes inicio',
    class: 'w-12',
    prop: 'startMonth'
  }, {
    id: '8',
    name: 'Mes término',
    class: 'w-5',
    prop: 'endMonth'
  },{
    id: '9',
    name: 'Mes previo',
    class: 'w-5',
    prop: 'prevMonth'
  },{
    id: '10',
    name: 'Moneda',
    class: 'w-5',
    prop: 'currency'
  },{
    id: '11',
    name: 'Gasto previo',
    class: 'w-5',
    prop: 'prevExpense'
  },{
    id: '12',
    name: 'Monto total',
    class: 'w-5',
    prop: 'totalAmount'
  },{
    id: '12',
    name: 'Código interno',
    class: 'w-4',
    prop: 'internalCode'
  },{
    id: '13',
    name: 'Action',
    class: 'w-10',
    prop: ''
  }],
};

export default TableHeads;